var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9131 3.26008L9.00646 1.52008C8.43313 1.26674 7.56646 1.26674 6.99312 1.52008L3.08646 3.26008C2.09979 3.70008 1.95312 4.30008 1.95312 4.62008C1.95312 4.94008 2.09979 5.54008 3.08646 5.98008L6.99312 7.72008C7.27979 7.84675 7.63979 7.91341 7.99979 7.91341C8.35979 7.91341 8.71979 7.84675 9.00646 7.72008L12.9131 5.98008C13.8998 5.54008 14.0465 4.94008 14.0465 4.62008C14.0465 4.30008 13.9065 3.70008 12.9131 3.26008Z",
    fill: "url(#paint0_linear_1612_269)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00021 11.3599C7.74687 11.3599 7.49354 11.3066 7.26021 11.2066L2.76688 9.20659C2.08021 8.89992 1.54688 8.07992 1.54688 7.32659C1.54688 7.05325 1.76687 6.83325 2.04021 6.83325C2.31354 6.83325 2.53354 7.05325 2.53354 7.32659C2.53354 7.68659 2.83354 8.15325 3.16687 8.29992L7.66021 10.2999C7.87354 10.3933 8.12021 10.3933 8.33354 10.2999L12.8269 8.29992C13.1602 8.15325 13.4602 7.69325 13.4602 7.32659C13.4602 7.05325 13.6802 6.83325 13.9535 6.83325C14.2269 6.83325 14.4469 7.05325 14.4469 7.32659C14.4469 8.07325 13.9135 8.89992 13.2269 9.20659L8.73354 11.2066C8.50688 11.3066 8.25354 11.3599 8.00021 11.3599Z",
    fill: "url(#paint1_linear_1612_269)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00021 14.6666C7.74687 14.6666 7.49354 14.6132 7.26021 14.5132L2.76688 12.5132C2.02688 12.1866 1.54688 11.4466 1.54688 10.6332C1.54688 10.3599 1.76687 10.1399 2.04021 10.1399C2.31354 10.1399 2.53354 10.3599 2.53354 10.6332C2.53354 11.0532 2.78021 11.4332 3.16687 11.6066L7.66021 13.6066C7.87354 13.6999 8.12021 13.6999 8.33354 13.6066L12.8269 11.6066C13.2069 11.4399 13.4602 11.0532 13.4602 10.6332C13.4602 10.3599 13.6802 10.1399 13.9535 10.1399C14.2269 10.1399 14.4469 10.3599 14.4469 10.6332C14.4469 11.4466 13.9669 12.1799 13.2269 12.5132L8.73354 14.5132C8.50688 14.6132 8.25354 14.6666 8.00021 14.6666Z",
    fill: "url(#paint2_linear_1612_269)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1612_269",
    x1: 1.99632,
    y1: 4.62153,
    x2: 14.0484,
    y2: 4.55692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1612_269",
    x1: 1.59295,
    y1: 9.09644,
    x2: 14.4485,
    y2: 8.98953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1612_269",
    x1: 1.59295,
    y1: 12.4031,
    x2: 14.4485,
    y2: 12.2962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerLayer);
export default __webpack_public_path__ + "static/media/ser_layer.e5af280df652ad15ee37e1351bc4028b.svg";
export { ForwardRef as ReactComponent };